import StartNewCartModalBlock, {
  StartNewCartModalBlockProps,
} from "./StartNewCartModalBlock";
import withInteractor from "./StartNewCartModalBlock.interactor";
import withPresenter from "./StartNewCartModalBlock.presenter";

export type { StartNewCartModalBlockProps };
export default withInteractor(withPresenter(StartNewCartModalBlock));
